import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import CmsContent from '../components/CmsContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import ExploreMore from '../components/ExploreMore'; 
import GetInTouch from '../components/GetInTouch'; 
import CareerPages from '../components/CareerPages'; 
import OurJourney from '../components/OurJourney'; 
import Ecosystem from '../components/Ecosystem'; 
import { Helmet } from "react-helmet";
import { base_url} from '../common/Constants';
import withRouter from '../components/withRouter';
 
class Cms extends React.Component{

    constructor(props){
        super(props); 

        this.state = { 
            loading:1,
            content:"",
        }
    }

     componentDidMount()
    {
        
       var slug = this.props.params.slug;
       var cms = JSON.parse(localStorage.getItem("slugcontent"));
       this.setState({content:cms[slug]});  
       this.setState({loading:0});  

       console.log(slug);
    }

     componentDidUpdate(prevProps)
    {
        if(this.props.params.slug !== prevProps.params.slug)
        {
            var slug = this.props.params.slug;
            var cms = JSON.parse(localStorage.getItem("slugcontent"));
            this.setState({content:cms[slug]});  
            this.setState({loading:0});  
        }
    }
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));

          if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
        return (
            <div className="page-block" data-v-e8f34808="">
                <Header/> 
                <Helmet>
                    <title>{metas[0].title}</title>  
                    <meta name="description" content={metas[0].meta_description} />
                    <meta name="keywords" content={metas[0].meta_title} />
                    <meta property="og:image" content={content[9].image}  />
                    <link rel="canonical" href={base_url} />
                </Helmet>
                <PageHeader title={this.state.content.slug == "abudhabi"  ?  "AbuDhabi" :( this.state.content.title || "")}  banner={this.state.content.image || ""} page={this.state.content.page || ""}   />
                {this.state.content.slug != "our-journey" &&  this.state.content.slug != "ecosystem" &&  
                <CmsContent content={this.state.content}/>
                }
                
                {(content.page == "Careers" || this.state.content.slug ==  "recruitment-policy" ||  this.state.content.slug ==  "internship" ||
                  this.state.content.slug ==  "apprenticeship" ) &&  
                <CareerPages content={JSON.parse(localStorage.getItem("content"))}/>
                 }
                {this.state.content.slug == "our-journey" &&  
                <OurJourney content={JSON.parse(localStorage.getItem("content"))}/>
                 }
                {this.state.content.slug == "ecosystem" &&  
                <Ecosystem content={JSON.parse(localStorage.getItem("content"))}/>
                 }
                {content.page != "Careers"  &&  this.state.content.slug !==  "recruitment-policy" && this.state.content.slug !==  "internship" &&
                  this.state.content.slug !==  "apprenticeship" &&
                 <ExploreMore content={JSON.parse(localStorage.getItem("content"))}/> 
                } 
                
                <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>
    
                
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(Cms);